export const text = {
  TodoId: "Todo Id",
  TeamId: "Team Id",
  TeamName: "Team Name",
  MyTeam: "My Team",
  AddMyTeam: "Add My Team",
  TeamName: "Team Name",
  TodoType: "Todo Type",
  SelectTodoType: "Select Todo Type",
  Poll: "Poll",
  Subjective: "Subjective",
  Objective: "Objective",
  AddTeamTodo: " Add Team Todo",
  AddTeamGroup: "Add Team Group",
  Pleaseaddteamgroupname: "Please add team group name",
  Teamgroupaddedsuccessfully: "Team group added successfully!",
  Teamgroupupdatedsuccessfully: "Team group updated successfully!",
  TeamTodo: "Team Todo",
  TodoSubmission: "Todo Submission",
  TeamGroup: "Team Group",
  Myteamaddedsuccessfully: "My team added successfully!",
  Myteamupdatedsuccessfully: "My team updated successfully",
  MyteamDeletedsuccessfully: "My team deleted successfully!",
  PleaseaddQuestiontoyourteamtodo: "Please add question to your team todo",
  Teamtodoaddedsuccessfully: "Team todo added successfully!",
  Teamtodoupdatedsuccessfully: "Team todo updated successfully!",
  Teamtododeletedsuccessfully: "Team todo deleted successfully!",
  Teamtodocancelledsuccessfully: "Team todo cancelled successfully!",
  Teamtodosubmittedsuccessfully: "Team todo submitted successfully!",
  TeamGroupdeletedsuccessfully: "Team Group deleted successfully!",
  Employee: "Employee",
};
